import React from 'react';
import styled from 'styled-components';
import { Form } from 'antd';
import { theme } from 'utils/style/theme';

/**
 * * 기본 폼
 * - 기본 모달 안에 많이 쓰인다.
 * - 이미지 첨부일 때 쓰인다.
 */

interface IProps {
  children?: JSX.Element[] | JSX.Element;
  // form?: FormInstance[] | undefined;
  form?: any;
  onFinish?: () => void;
  style?: React.CSSProperties;
  margin?: string;
}

const DefaultForm = ({
  children,
  form,
  onFinish,
  style,
  margin = '1rem 0.5rem',
}: IProps) => {
  return (
    <FormStyled
      form={form}
      onFinish={onFinish}
      layout='vertical'
      style={style}
      margin={margin}
    >
      {children}
    </FormStyled>
  );
};

export default DefaultForm;

const FormStyled = styled(Form)<IProps>`
  margin: ${(props) => props.margin};

  /* 압축 파일 올릴 때, 프로젝트 제목 */
  h6 {
    font-size: 1.3rem;
    font-weight: 700;
    text-align: center;
    margin-bottom: 1rem;
  }
  /* 이미 기입된 아이디나 타이틀 출력할 때 */
  .title_wrap {
    display: flex;
    align-items: center;
    margin-bottom: 1.4rem;
    margin-left: 0.15rem;
    p {
      margin-right: 0.5rem;
      font-weight: 600;
      font-size: 0.9rem;
      color: ${theme.colors.black};
    }
    span {
      font-weight: 700;
      font-size: 1.2rem;
      color: ${theme.colors.black};
    }
  }

  &.ant-form-vertical .ant-form-item-label {
    padding: 0 0 0.2rem 0;
  }
  .ant-form-item-label > label {
    font-weight: 600;
    font-size: 0.9rem;
    color: ${theme.colors.black};
    margin-left: 0.2rem;
  }
  .horizontal_wrap {
    h3 {
      font-weight: 600;
      margin-right: 0.5rem;
      color: ${theme.colors.blue_7};
      font-size: ${theme.fontSizes.md};
      margin-left: 0.5rem;
      margin-bottom: 0.2rem;
    }

    display: flex;
    align-items: center;
  }
  .submit_button_wrap {
    text-align: center;
  }
  /* <Form.Item> 태그를 사용할 수 없을 때 */
  .flex_form_item {
    display: flex;
    align-items: center;
    margin-bottom: 1.5rem;
    p {
      font-weight: 600;
      font-size: 0.9rem;
      color: ${theme.colors.black};
      margin: -0.4rem 1rem 0rem 0.2rem;
    }
  }

  //테이블에 + - 추가버튼 있을 때
  .table_row_button {
    transform: translate(0, -1rem);
    margin: 0.5rem 0;
    .ant-form-item-control-input-content {
      margin-top: 0;
      display: flex;
      flex-direction: row;
    }
  }

  .alert {
    color: ${theme.colors.redText};
  }

  .project_premium_pass {
    position: relative;
    .ant-form-item-label {
      text-align: center;
    }
    label {
      width: 100%;
      display: block;
    }
    p {
      position: absolute;
      top: -0.5rem;
      &:nth-child(1) {
        left: 16.5rem;
      }
      &:nth-child(2) {
        left: 33.5rem;
      }
    }
  }
`;
